import { MetricCard } from "@app/components/Dashboard/chart/MetricCard";
import { DetailChartSection } from "@app/components/Dashboard/section/MetricSection/DetailChart";
import { toTimestamp } from "@app/components/Dashboard/utils/timestamp";
import { useGetListStatisticsReportMetricsGet } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import { useDashboardContext } from "../../DashboardProvider";
import { Fragment, useEffect, useState } from "react";

interface MetricSectionProps {
  onDataState?: (empty: boolean) => void;
}

export const MetricSection = ({
  onDataState,
  ...props
}: MetricSectionProps) => {
  const { timeWindow, customDateRange, setDataIsEmpty, groupFilter } =
    useDashboardContext();

  const [selectedMetrics, setSelectedMetrics] =
    useState<any>("view_started_count");
  const [dateExists, setDataExists] = useState<boolean>(false);
  // 쿼리로 변경
  const {
    data: metrics,
    isLoading,
    isSuccess: isSuccessGetListStatisticsReport,
  } = useGetListStatisticsReportMetricsGet({
    // camel로 변경 필요
    time_window: timeWindow,
    start_date: customDateRange
      ? toTimestamp(customDateRange.startDate)
      : undefined,
    end_date: customDateRange
      ? toTimestamp(customDateRange.endDate)
      : undefined,
    group_ids: groupFilter?.map((group) => group.id) || [],
  });

  useEffect(() => {
    // @ts-ignore
    if (metrics?.data.view_started_count.length < 1) {
      setDataExists(false);
      setDataIsEmpty?.(true);
    } else {
      setDataExists(true);
      setDataIsEmpty?.(false);
    }
  }, [isSuccessGetListStatisticsReport]);

  const handleClick = (id: string) => {
    setSelectedMetrics(id);
  };

  const getName = (id: string) => {
    switch (id) {
      case "viewed_count":
        return "조회수";
      case "total_viewed_duration":
        return "시청시간";
      case "product_clicked_count":
        return "상품 클릭 수";
      default:
        return "";
    }
  };

  const getFormatById = (id: string) => {
    switch (id) {
      case "total_viewed_duration":
        return "time";
      case "traffics":
        return "filesize";
      default:
        return "number";
    }
  };

  return (
    <Fragment>
      {isLoading && (
        <div className="flex flex-shrink items-center justify-center sm:h-dvh md:h-36">
          <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
        </div>
      )}
      {isSuccessGetListStatisticsReport && (
        <>
          {dateExists && (
            <Fragment>
              <div className="grid border border-gray-200 sm:grid-cols-2 md:grid-cols-4 cursor-pointer">
                <MetricCard
                  id="view_started_count"
                  report={metrics}
                  title="조회수"
                  selected={selectedMetrics === "view_started_count"}
                  onClick={handleClick}
                />
                <MetricCard
                  id="total_viewed_duration"
                  report={metrics}
                  title="시청시간"
                  format="time"
                  selected={selectedMetrics === "total_viewed_duration"}
                  onClick={handleClick}
                />
                <MetricCard
                  id="product_clicked_count"
                  report={metrics}
                  title="상품 클릭 수"
                  selected={selectedMetrics === "product_clicked_count"}
                  onClick={handleClick}
                />
                <MetricCard
                  id="traffics"
                  report={metrics}
                  title="트래픽"
                  format="filesize"
                  selected={selectedMetrics === "traffics"}
                  onClick={handleClick}
                />
              </div>
              <DetailChartSection
                format={getFormatById(selectedMetrics)}
                name={getName(selectedMetrics)}
                data={metrics?.data?.[selectedMetrics]}
              />
            </Fragment>
          )}
          {!dateExists && (
            <div className="h-72 items-center justify-center">
              데이터가 없습니다.
            </div>
          )}
        </>
      )}
    </Fragment>
  );
};
